export const rangeTable = {
  1: 33,
  2: 28,
  3: 25,
  4: 23,
  5: 22,
  6: 20,
  7: 19,
  8: 18,
  9: 17,
  11: 16,
  12: 15,
  14: 14,
  16: 13,
  19: 12,
  22: 11,
  25: 10,
  30: 9,
  35: 8,
  40: 7,
  45: 6,
  50: 5,
  55: 4,
  65: 3,
  75: 2,
  85: 1,
  100: 0,
  115: -1,
  130: -2,
  150: -3,
  170: -4,
  200: -5,
  230: -6,
  250: -7,
  300: -8,
  350: -9,
  400: -10,
  450: -11,
  500: -12,
  600: -13,
  700: -14,
};
